/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2023, Zumper
 */

import { getEnumTitle, PropertyFeatures } from '@zcode/enums'

export const mapOrFeatures = (features: readonly PropertyFeatures[]) => {
  return features.map((feature) => {
    return feature === PropertyFeatures.SPECIALS
      ? 'Rent Special'
      : getEnumTitle(PropertyFeatures, feature)
  })
}
